// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../node_modules/react-native-vector-icons/Fonts/Feather.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* react-native-vector-icons ships icon glyphs as bundled .ttf fonts (used
   natively via font linking) — on web they need to be loaded as ordinary
   web fonts instead. Only the two families actually used in this app
   (see the Phase 0 audit) are wired up here; more can be added the same
   way as later phases port more screens. */
@font-face {
  font-family: "Feather";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "FontAwesome";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
`, "",{"version":3,"sources":["webpack://./web/icons.css"],"names":[],"mappings":"AAAA;;;;2CAI2C;AAC3C;EACE,sBAAsB;EACtB,+DAA0F;EAC1F,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+DAA8F;EAC9F,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["/* react-native-vector-icons ships icon glyphs as bundled .ttf fonts (used\n   natively via font linking) — on web they need to be loaded as ordinary\n   web fonts instead. Only the two families actually used in this app\n   (see the Phase 0 audit) are wired up here; more can be added the same\n   way as later phases port more screens. */\n@font-face {\n  font-family: \"Feather\";\n  src: url(\"../node_modules/react-native-vector-icons/Fonts/Feather.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"FontAwesome\";\n  src: url(\"../node_modules/react-native-vector-icons/Fonts/FontAwesome.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
